import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { FlaskConical, Beaker, Trophy, Ruler } from "lucide-react";

const formulas = [
  {
    icon: FlaskConical,
    name: "Jackson-Pollock 7",
    specs: "7 pliegues · 18-61 años",
    description: "Población general + atletas",
  },
  {
    icon: Beaker,
    name: "Jackson-Pollock 4",
    specs: "4 pliegues · 18-61 años",
    description: "Más práctica y rápida",
  },
  {
    icon: Trophy,
    name: "Yuhasz",
    specs: "6 sitios · Sin límite de edad",
    description: "Ideal para alto rendimiento",
  },
  {
    icon: Ruler,
    name: "Durnin-Womersley",
    specs: "4 pliegues · 17-72 años",
    description: "Coeficientes por edad y sexo",
  },
];

export const ScienceSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      ref={ref}
      className="relative py-24 md:py-32 px-6 md:px-12"
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16 md:mb-20">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5 }}
            className="inline-block text-[#E05D3A] text-sm font-semibold tracking-widest uppercase mb-4"
          >
            Ciencia Real
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight mb-6"
          >
            4 fórmulas validadas. <span className="text-gradient">Cero margen de error.</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="text-zinc-400 text-base sm:text-lg max-w-2xl mx-auto"
          >
            Calculamos el porcentaje de grasa corporal con las 4 fórmulas más respetadas 
            de la ciencia del deporte. Tú eliges cuáles activar.
          </motion.p>
        </div>

        {/* Formula Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {formulas.map((formula, index) => (
            <motion.div
              key={formula.name}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.3 + index * 0.1 }}
              className="group relative p-6 rounded-2xl bg-white/[0.02] border border-white/10 hover:bg-white/[0.04] hover:border-[#E05D3A]/30 transition-all duration-300"
              data-testid={`formula-card-${index}`}
            >
              {/* Icon */}
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#E05D3A]/10 text-[#E05D3A] mb-4 group-hover:scale-110 transition-transform duration-300">
                <formula.icon className="w-6 h-6" />
              </div>

              {/* Content */}
              <h3 className="font-outfit text-lg font-medium text-white mb-2">
                {formula.name}
              </h3>
              <p className="text-[#E05D3A] text-xs font-medium mb-2">
                {formula.specs}
              </p>
              <p className="text-zinc-500 text-sm">
                {formula.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
